import { ChartArea } from 'chart.js';

type DrawDashLineOptions = {
  pointX: number;
  pointY: number;
  gapFromStart: number;
};

export const drawDashLine = (
  ctx: CanvasRenderingContext2D,
  chartArea: ChartArea,
  options: DrawDashLineOptions,
  color: string,
) => {
  const { bottom } = chartArea;
  const { pointX, pointY, gapFromStart } = options;

  const isInChartArea = pointY + gapFromStart < bottom;

  if (isInChartArea) {
    ctx.save();
    ctx.beginPath();
    ctx.moveTo(pointX, pointY + gapFromStart);
    ctx.lineTo(pointX, bottom);
    ctx.lineWidth = 1;
    ctx.strokeStyle = color;
    ctx.setLineDash([5, 5]);
    ctx.stroke();
    ctx.restore();
  }
};
